import React from 'react';
import cn from 'classnames';
import s from './threeDots.scss';

const ThreeDots = ({className = ''}) => (
  <div className={cn(s.loader, className)} />
);

export {ThreeDots};
